import type { IconProps } from './types';

export const ChevronLeftIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth={1.5}
            {...props}
        >
            <path d="M13.501 7.0498L8.80862 11.9996L13.501 16.9493" stroke="currentColor" />
        </svg>
    );
};
